export default __webpack_public_path__ + "static/media/man8.7b23b173.JPG";